import { HiArrowPath } from "react-icons/hi2";

type MapRedoSearchChipProps = {
  visible: boolean;
  loading?: boolean;
  onClick: () => void;
};

export default function MapRedoSearchChip({
  visible,
  loading,
  onClick,
}: MapRedoSearchChipProps) {
  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className="absolute bottom-[calc(1rem+env(safe-area-inset-bottom,0px)+40px+12px)] left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-full border border-[#1562fc] bg-white px-4 py-2.5 text-sm font-semibold text-[#1562fc] shadow-md shadow-black/10 transition-colors active:bg-gray-50 disabled:opacity-60"
    >
      <HiArrowPath
        className={`h-5 w-5 shrink-0 ${loading ? "animate-spin" : ""}`}
        aria-hidden
      />
      현 지도에서 재검색
    </button>
  );
}
